// @ts-nocheck
import { useRef } from 'react';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"


export const SliceSpaceComponents = (props) => {
    const toast = useRef(null);
    const setSliceSpace = () => {
        toast.current.show({ severity: 'info', summary: '分析資訊', detail: '左鍵點擊後開始' });
        window.main.OView.setSliceSpace();
        props.setIsSliceSpace(true);
    }
    const editSliceSpace = () => {
        window.main.OView.editSliceSpace();
    }
    const removeSliceSpace = () => {
        window.main.OView.abortInput();
        window.main.OView.removeSliceSpace();
        props.setIsSliceSpace(false);
    }
    return (
        <div>
            <Toast ref={toast} />
            <div className="field grid">
                <div className="col-12 md:col-4" style={{ alignSelf: 'center' }}>
                    <Button label="開始" icon="pi pi-check" className="p-button-rounded p-button-info" onClick={setSliceSpace} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-4" style={{ alignSelf: "center", textAlign: "center" }}>
                    <Button label="編輯" icon="pi pi-pencil" className="p-button-rounded p-button-warning" disabled={!props.isSliceSpace} onClick={editSliceSpace} style={{ width: "100%" }} />
                </div>
                <div className="col-12 md:col-4" style={{ alignSelf: "center", textAlign: "center" }}>
                    <Button label="清除" icon="pi pi-trash" className="p-button-rounded p-button-danger" disabled={!props.isSliceSpace} onClick={removeSliceSpace} style={{ width: "100%" }} />
                </div>
            </div>
        </div>
    )
}